import UserMixin from './UserMixin'

export default {
    mixins: [
        UserMixin
    ]
}